import { render } from "./CircleLoader.vue?vue&type=template&id=3ca06956&scoped=true"
import script from "./CircleLoader.vue?vue&type=script&lang=js"
export * from "./CircleLoader.vue?vue&type=script&lang=js"

import "./CircleLoader.vue?vue&type=style&index=0&id=3ca06956&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca06956"]])

export default __exports__